import '../../assets/css/case-home.css';
import '../../assets/css/case-property.css';
import type { ComponentContentSchema } from '@vibesites/runtime';
// @ts-ignore
import { useContentToken, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { VibesitesImage } from '@vibesites/ui-primitives';
import cornerIcon from '../../assets/images/case-image-corner.svg';

export function CareersIntro() {
  const ctaText = useContentToken('careersintro.cta_text');
  const ctaUrl = useContentToken('careersintro.cta_url');
  const image0 = useContentToken('careersintro.image_0');
  const image1 = useContentToken('careersintro.image_1');
  const image2 = useContentToken('careersintro.image_2');

  return (
    <section className="case-careerspage-intro">
      <div className="case-container">
        <div className="case-careerspage-intro-text">
          <RichTextContent
            path="careersintro.body"
            label="Intro Text"
            defaultValue={contentSchema.tokens['careersintro.body'].defaultValue}
            as="p"
            style={{ fontSize: '1rem', lineHeight: 1.6, marginBottom: '1.5rem', maxWidth: 800 }}
          />
        </div>

        <div className="case-careerspage-grid">
          <div>
            <div className="case-careerspage-eeo">
              <EditableToken
                path="careersintro.eeo_heading"
                type="text"
                label="EEO Heading"
                defaultValue={contentSchema.tokens['careersintro.eeo_heading'].defaultValue}
                as="h1"
              >
                {useContentToken('careersintro.eeo_heading')}
              </EditableToken>
              <div className="case-careerspage-eeo-divider" />
              <RichTextContent
                path="careersintro.eeo_body"
                label="Equal Opportunity Statement"
                defaultValue={contentSchema.tokens['careersintro.eeo_body'].defaultValue}
                as="div"
              />
            </div>
            <EditableToken path="careersintro.cta_url" type="url" label="CTA URL" defaultValue={contentSchema.tokens['careersintro.cta_url'].defaultValue} as="span" style={{ display: 'contents' }}>
              <EditableToken path="careersintro.cta_text" type="text" label="CTA Button Text" defaultValue={contentSchema.tokens['careersintro.cta_text'].defaultValue} as="span" style={{ display: 'contents' }}>
                <a className="case-btn" href={ctaUrl ?? undefined} target="_blank" rel="noopener noreferrer">{ctaText}</a>
              </EditableToken>
            </EditableToken>
          </div>

        <div className="case-careerspage-image-grid">
            <EditableToken path="careersintro.image_0" type="image" label="Careers Image 1" defaultValue="" as="div" className="case-careerspage-image-slot">
              <VibesitesImage url={image0 as string} alt="" width={400} height={300} />
            </EditableToken>
          <div className="case-careerspage-image-frame">
              <img src={cornerIcon} alt="" className="prop-corner-icon prop-corner-icon--tr" aria-hidden="true" />
              <EditableToken path="careersintro.image_1" type="image" label="Careers Image 2" defaultValue="" as="div" className="case-careerspage-image-slot">
                <VibesitesImage url={image1 as string} alt="" width={400} height={300} />
              </EditableToken>
            </div>
            <EditableToken path="careersintro.image_2" type="image" label="Careers Image 3" defaultValue="" as="div" className="case-careerspage-image-slot">
              <VibesitesImage url={image2 as string} alt="" width={400} height={300} />
            </EditableToken>
          </div>
        </div>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'CareersIntro',
  displayName: 'Careers Intro',
  tokens: {
    'careersintro.body': {
      label: 'Intro Text',
      type: 'richtext',
      defaultValue: 'Find a great career at a great company with Case &amp; Associates. We are always looking for enthusiastic and talented individuals to join our team. In return, we offer competitive wages, an excellent benefits package, and a supportive work environment. Be sure to search all of our open positions to find the perfect fit for you!',
    },
    'careersintro.eeo_heading': {
      label: 'EEO Heading',
      type: 'text',
      defaultValue: 'Start on a New Path',
    },
    'careersintro.eeo_body': {
      label: 'Equal Opportunity Statement',
      type: 'richtext',
      defaultValue: '<p><strong>We are an Equal Opportunity Employer.</strong></p><p>Case &amp; Associates Properties, Inc. and its affiliates prohibit discrimination against a job applicant or an employee because of the person\u2019s race, color, religion, sex, national origin, age, disability or any other status protected by local, state or federal laws. These prohibitions are required by federal, state and/or local law and this reaffirmation is not intended to create any contractual rights or remedies, or alter the administrative requirements or limitation periods of local, state and federal laws.</p>',
    },
    'careersintro.cta_text': {
      label: 'CTA Button Text',
      type: 'text',
      defaultValue: 'Open Positions',
    },
    'careersintro.cta_url': {
      label: 'CTA URL',
      type: 'url',
      defaultValue: 'https://phe.tbe.taleo.net/phe03/ats/careers/v2/jobSearch?act=redirectCwsV2&cws=38&org=CASEUSA',
    },
    'careersintro.image_0': {
      label: 'Careers Image 1',
      type: 'image',
      defaultValue: '',
    },
    'careersintro.image_1': {
      label: 'Careers Image 2',
      type: 'image',
      defaultValue: '',
    },
    'careersintro.image_2': {
      label: 'Careers Image 3',
      type: 'image',
      defaultValue: '',
    },
  },
};

(CareersIntro as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default CareersIntro;
